












































    import {Vue, Component, Emit, Prop} from 'vue-property-decorator'
import dataProxy from "@/services/data-proxy.service";
    import {RezervniDeo, StavkaDokumenta, ZalihaRezervnogDela} from "@/services/BackendProxies";
    import {mixins} from "vue-class-component";
    import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class PretragaRezervnihDelova extends mixins(ComponentBaseMixin) {
    @Prop() skladiste!: number;
    rezervniDelovi: ZalihaRezervnogDela[] = [];

    sifra = '';
    kataloskiBroj = '';
    naziv = '';
    stavkaDokumenta: StavkaDokumenta = new StavkaDokumenta();
    columns = [];
    dialogRezervniDeoOtvoren = false;

    async created() {
        this.rezervniDelovi = await this.loadData(() => dataProxy.vratiRezervneDeloveUSkladistu(this.skladiste))();
        this.columns = [
            {field: 'sifra', title: this.$i18n.t('sifra')},
            {field: 'kataloskiBroj', title: this.$i18n.t('kataloskiBroj')},
            {field: 'naziv', title: this.$i18n.t('naziv')},
            {field: 'kolicina', title: this.$i18n.t('zaliha')},
        ];
    }

    otvoriUnosKolicine(rezervniDeo: ZalihaRezervnogDela) {
        this.stavkaDokumenta = StavkaDokumenta.fromJS({rezervniDeoId: rezervniDeo.rezervniDeoId, rezervniDeo: rezervniDeo.naziv});
        this.dialogRezervniDeoOtvoren = true;
    }

    dodajRezervniDeoDokumentu() {
        this.izabranRezerniDeo(this.stavkaDokumenta);
    }

    @Emit() izabranRezerniDeo(stavkaDokumenta: StavkaDokumenta) {
        this.dialogRezervniDeoOtvoren = !stavkaDokumenta.kolicina;
    }

    get rezervniDeloviFiltered() {
        let delovi = this.rezervniDelovi;

        if (this.sifra) {
            delovi = delovi.filter(d => d.sifra && d.sifra.replace(/-|\s/g,"").match(this.sifra.toUpperCase().replace(/-|\s/g,"")));
        }
        if (this.kataloskiBroj) {
            delovi = delovi.filter(d => d.kataloskiBroj && d.kataloskiBroj.replace(/-|\s/g,"").match(this.kataloskiBroj.toUpperCase().replace(/-|\s/g,"")));
        }

        if (this.naziv) {
            delovi = delovi.filter(d => d.naziv && d.naziv.replace(/-|\s/g,"").match(this.naziv.toUpperCase().replace(/-|\s/g,"")));
        }
        /*if (this.serijskiBroj !== '') {
            delovi = delovi.filter(d => d.serijskiBroj.replace(/-|\s/g,"").match(this.serijskiBroj.toUpperCase().replace(/-|\s/g,"")));
        }
        if (this.oemBroj !== '') {
            delovi = delovi.filter(d => d.oem.replace(/-|\s/g,"").match(this.oemBroj.toUpperCase().replace(/-|\s/g,"")));
        }*/
        return delovi;
    }

    fokusirajKolicinu() {
        (<HTMLElement>this.$refs.kolicina).focus();
    }
}
